<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">نسخه ۲.۹.۱</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">تمامی حقوق این فناوری برای </span>
      <a href="https://hamkaran.cloud">
        &copy; شرکت طرح و توسعه پردازش همکاران
      </a>
      <span class="mr-1" target="_blank"> محفوظ می‌باشد.</span>
    </div>
    <div v-for="count in this.$store.state.alert.errorcount" :key="count">
      <CAlert color="danger" class="notifi" closeButton :show="5">
        <b>
          {{ $store.state.alert.error_msg.statusText }}({{
            $store.state.alert.error_msg.status
          }})
        </b>
        <div
          v-for="(msg, index) in $store.state.alert.error_msg.data[0]"
          :key="index"
        >
          {{ msg[0] }}
          <br />
        </div>
      </CAlert>
    </div>
    <div v-for="count in this.$store.state.alert.successcount" :key="count">
      <CAlert
        color="success"
        class="notifi"
        style="width: 250px;"
        closeButton
        :show="5"
      >
        <b>
          {{ $store.state.alert.successMessage }}
        </b>
      </CAlert>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
